var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHotAirBalloon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f4a72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b395f"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 207.539,
    x2: 302.461,
    xlinkHref: "#lg1",
    y1: 422.068,
    y2: 422.068
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a34a9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1962,
    stopColor: "#a04d90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5665,
    stopColor: "#97566b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c6239"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.336,
    x2: 263.244,
    xlinkHref: "#lg2",
    y1: 433.34,
    y2: 509.943
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b395f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b395f"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.55,
    x2: 257.737,
    xlinkHref: "#lg3",
    y1: 497.208,
    y2: 530.886
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.569,
    x2: 257.842,
    xlinkHref: "#lg3",
    y1: 476.243,
    y2: 511.245
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.567,
    x2: 257.866,
    xlinkHref: "#lg3",
    y1: 454.965,
    y2: 490.365
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 248.027,
    x2: 295.806,
    xlinkHref: "#lg3",
    y1: 443.805,
    y2: 595.006
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 247.859,
    x2: 288.973,
    xlinkHref: "#lg3",
    y1: 448.814,
    y2: 578.923
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 261.017,
    x2: 241.37,
    xlinkHref: "#lg3",
    y1: 466.951,
    y2: 377.837
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.162,
    x2: 256.765,
    xlinkHref: "#lg2",
    y1: 418.794,
    y2: 449.782
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 211.503,
    x2: 298.497,
    xlinkHref: "#lg1",
    y1: 394.71,
    y2: 394.71
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 78.159,
    x2: 431.841,
    y1: 210.695,
    y2: 210.695
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3fa9f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666ad6"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 122.329,
    x2: 387.671,
    y1: 203.534,
    y2: 203.534
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c4f8b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b8eac"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 172.372,
    x2: 337.629,
    y1: 199.684,
    y2: 199.684
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1758,
    stopColor: "#ffde50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4446,
    stopColor: "#ffca65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#ffaa87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff90a4"
  }))), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 220.181,
    x2: 289.819,
    y1: 196.022,
    y2: 196.022
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2231,
    stopColor: "#fb3f6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6075,
    stopColor: "#f12357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4003d"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 252.121,
    x2: 262.274,
    xlinkHref: "#lg1",
    y1: 361.824,
    y2: 397.991
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m302.461 437.651h-94.922v-15.091c0-8.865 7.212-16.077 16.076-16.077h62.769c8.865 0 16.077 7.212 16.077 16.077zm-88.828-6.094h82.734v-8.997c0-5.505-4.478-9.983-9.983-9.983h-62.769c-5.504 0-9.982 4.478-9.982 9.983z",
    fill: "url(#SVGID_1_)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m285.532 510h-61.064c-6.549 0-12.052-4.921-12.781-11.429l-6.792-60.632h100.21l-6.792 60.632c-.729 6.508-6.232 11.429-12.781 11.429z",
    fill: "url(#SVGID_2_)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m298.313 498.571 1.101-9.829h-88.828l1.101 9.829c.729 6.508 6.232 11.429 12.781 11.429h61.064c6.549 0 12.052-4.921 12.781-11.429z",
    fill: "url(#SVGID_3_)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m299.414 488.742 2.381-21.258h-93.59l2.381 21.258z",
    fill: "url(#SVGID_4_)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m301.795 467.484 2.382-21.257h-98.354l2.382 21.257z",
    fill: "url(#SVGID_5_)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m281.643 510h-53.286l-5.116-72.061h63.518z",
    fill: "url(#SVGID_6_)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m263.415 510h-16.83l-1.616-72.061h20.062z",
    fill: "url(#SVGID_7_)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m204.895 437.939.783 6.989 65.072 65.072h14.782c6.549 0 12.052-4.921 12.781-11.429l6.792-60.632z",
    fill: "url(#SVGID_8_)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m300.035 445.781h-90.07c-6.173 0-11.177-5.004-11.177-11.177 0-6.173 5.004-11.177 11.177-11.177h90.07c6.173 0 11.177 5.004 11.177 11.177 0 6.173-5.004 11.177-11.177 11.177z",
    fill: "url(#SVGID_9_)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m290.26 412.578h-70.52l-8.238-35.736h86.994zm-65.366-6.094h60.212l6.186-23.549h-72.585z",
    fill: "url(#SVGID_10_)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m282.631 30.949c-18.366 2.091-36.897 2.091-55.263 0-49.736-5.662-149.209-2.368-149.209 114.588 0 126.722 96.362 154.58 131.802 230.012 4.744 10.098 14.953 16.495 26.111 16.495h18.928 18.929c11.157 0 21.366-6.397 26.111-16.495 35.44-75.432 131.802-103.289 131.802-230.012-.001-116.956-99.474-120.251-149.211-114.588z",
    fill: "url(#SVGID_11_)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m275.73 16.689c-13.742 2.168-27.718 2.168-41.46 0-37.314-5.886-111.941-2.461-111.941 119.113 0 130.33 70.768 160.058 98.02 236.617 4.167 11.705 15.113 19.624 27.538 19.624h7.113 7.113c12.425 0 23.371-7.919 27.538-19.624 27.252-76.558 98.02-106.287 98.02-236.617 0-121.574-74.627-124.999-111.941-119.113z",
    fill: "url(#SVGID_12_)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m267.911 9.025c-8.48 2.192-17.341 2.192-25.821 0-23.239-6.006-69.718-2.512-69.718 121.545 0 136.112 46.168 164.694 62.197 247.03 1.634 8.396 9.016 14.443 17.57 14.443h2.861 2.862c8.553 0 15.935-6.048 17.57-14.443 16.029-82.336 62.197-110.918 62.197-247.03 0-124.057-46.479-127.552-69.718-121.545z",
    fill: "url(#SVGID_13_)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m220.181 102.891c0 155.062 20.646 183.927 26.785 281.588.267 4.248 3.777 7.563 8.034 7.563 4.256 0 7.767-3.315 8.034-7.563 6.139-97.661 26.785-126.526 26.785-281.588 0-137.188-69.638-137.188-69.638 0z",
    fill: "url(#SVGID_14_)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m255 366.229c-17.59 0-33.786 2.184-46.729 5.849.577 1.145 1.141 2.301 1.689 3.469 4.744 10.098 14.953 16.495 26.111 16.495h11.816 4.251 2.862 2.862 4.251 11.816c11.157 0 21.366-6.397 26.111-16.495.549-1.168 1.112-2.324 1.689-3.469-12.943-3.664-29.139-5.849-46.729-5.849z",
    fill: "url(#SVGID_15_)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHotAirBalloon);
export default __webpack_public_path__ + "static/media/icon-hot-air-balloon.8781efc7c6fe916f0286d7e4d230881c.svg";
export { ForwardRef as ReactComponent };